module.exports = __webpack_public_path__ + "src/img/alert.73c8a45d.svg";